import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-lead-skeleton-loader',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="skeleton-container">
      <!-- Header skeleton -->
      <div class="lead-profile-header skeleton-header">
        <div class="header-left">
          <div>
            <div class="skeleton-text skeleton-title"></div>
            <div class="skeleton-text skeleton-subtitle"></div>
            <div class="skeleton-text skeleton-subtitle"></div>
          </div>
          <div class="second-div">
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
          </div>
        </div>
        <div class="header-right">
          <div class="skeleton-button"></div>
          <div class="skeleton-button"></div>
          <div class="skeleton-button"></div>
        </div>
      </div>

      <!-- Stepper skeleton -->
      <div class="stepper-container">
        <div class="skeleton-stepper">
          <div class="skeleton-step"></div>
          <div class="skeleton-step"></div>
          <div class="skeleton-step"></div>
          <div class="skeleton-step"></div>
        </div>
      </div>

      <!-- Container with left and right sections -->
      <div class="skeleton-body">
        <!-- Left section skeleton -->
        <div class="left-section">
          <div class="skeleton-card">
            <div class="skeleton-text skeleton-title"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
          </div>
          <div class="skeleton-card">
            <div class="skeleton-text skeleton-title"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
          </div>
          <div class="skeleton-card">
            <div class="skeleton-text skeleton-title"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
          </div>
          <div class="skeleton-card">
            <div class="skeleton-text skeleton-title"></div>
            <div class="skeleton-text skeleton-line"></div>
            <div class="skeleton-text skeleton-line"></div>
          </div>
        </div>
        
        <!-- Right section skeleton -->
        <div class="right-section">
          <div class="skeleton-tabs">
            <div class="skeleton-tab-header">
              <div class="skeleton-tab"></div>
              <div class="skeleton-tab"></div>
              <div class="skeleton-tab"></div>
            </div>
            <div class="skeleton-tab-content">
              <div class="skeleton-text skeleton-line"></div>
              <div class="skeleton-text skeleton-line"></div>
              <div class="skeleton-text skeleton-line"></div>
              <div class="skeleton-text skeleton-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
    styles: [
        `
    .skeleton-header {
  height: 10%;
  background-color: var(--skeleton-bg-card);
  display: flex;
  justify-content: space-between;
}

/* Improve layout structure to match the real component */
.skeleton-stepper {
  display: flex;
  justify-content: space-between;
  background-color: var(--skeleton-bg-card);
  height: 10%;
}

/* Make the container take the remaining height */
.skeleton-container {
  height: 94vh;
  display: flex;
  flex-direction: column;
}

.skeleton-body {
  display: flex;
  flex-wrap: wrap; /* Allows wrapping for small screens */
  height: 80%; /* Take up the remaining height */
  overflow: hidden;
}

.skeleton-text {
  background-color: var(--skeleton-shimmer-mid);
  border-radius: 4px;
  margin-bottom: 8px;
  animation: shimmer 1.8s infinite;
  background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
  background-size: 200% 100%;
  position: relative;
  overflow: hidden;
}

.skeleton-title {
  height: 24px;
  width: 200px;
}

.skeleton-subtitle {
  height: 16px;
  width: 300px;
}

.skeleton-line {
  height: 16px;
  width: 250px;
}

.skeleton-button {
  height: 36px;
  width: 80px;
  background-color: var(--skeleton-shimmer-mid);
  border-radius: 4px;
  margin-left: 8px;
  animation: shimmer 1.8s infinite;
  background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
  background-size: 200% 100%;
}

.skeleton-step {
  height: 30px;
  width: 100px;
  background-color: var(--skeleton-shimmer-mid);
  border-radius: 15px;
  animation: shimmer 1.8s infinite;
  background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
  background-size: 200% 100%;
}

.skeleton-card {
  background-color: var(--skeleton-bg-card);
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: var(--skeleton-shadow);
  animation: cardFadeIn 0.8s ease-in;
}

.skeleton-tabs {
  background-color: var(--skeleton-bg-card);
  border-radius: 4px;
  box-shadow: var(--skeleton-shadow);
  height: 100%;
  animation: cardFadeIn 0.9s ease-in;
}

.skeleton-tab-header {
  display: flex;
  padding: 8px 16px;
  border-bottom: 1px solid var(--skeleton-border-color);
}

.skeleton-tab {
  height: 20px;
  width: 100px;
  background-color: var(--skeleton-shimmer-mid);
  border-radius: 4px;
  margin-right: 16px;
  animation: shimmer 1.8s infinite;
  background: linear-gradient(90deg, var(--skeleton-shimmer-from) 25%, var(--skeleton-shimmer-mid) 50%, var(--skeleton-shimmer-to) 75%);
  background-size: 200% 100%;
}

.skeleton-tab-content {
  padding: 16px;
  height: calc(100% - 40px); /* Account for the tab header height */
}

/* Shimmer animation effect */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Card fade-in animation - removed vertical movement that caused the weird initial shift */
@keyframes cardFadeIn {
  0% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

/* Staggered animation for skeleton lines */
.skeleton-card:nth-child(1) .skeleton-line:nth-child(2) { animation-delay: 0.05s; }
.skeleton-card:nth-child(1) .skeleton-line:nth-child(3) { animation-delay: 0.1s; }
.skeleton-card:nth-child(1) .skeleton-line:nth-child(4) { animation-delay: 0.15s; }
.skeleton-card:nth-child(1) .skeleton-line:nth-child(5) { animation-delay: 0.2s; }

.skeleton-card:nth-child(2) { animation-delay: 0.1s; }
.skeleton-card:nth-child(3) { animation-delay: 0.2s; }
.skeleton-card:nth-child(4) { animation-delay: 0.3s; }

.skeleton-tab-content .skeleton-line:nth-child(1) { animation-delay: 0.05s; }
.skeleton-tab-content .skeleton-line:nth-child(2) { animation-delay: 0.1s; }
.skeleton-tab-content .skeleton-line:nth-child(3) { animation-delay: 0.15s; }
.skeleton-tab-content .skeleton-line:nth-child(4) { animation-delay: 0.2s; }

/* Keep the rest of the styles that are inherited from your main container */
.left-section {
  flex: 0 0 30%;
  max-width: 100%;
  height: 100%;
  padding: 16px;
  background-color: var(--skeleton-bg-secondary);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.right-section {
  flex: 1;
  max-width: 70%;
  padding: 16px;
  background-color: var(--skeleton-bg-secondary);
  height: 100%;
}

.lead-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  height: 10%;
  background-color: var(--skeleton-bg-card);
}

.header-left {
  display: flex;
  gap: 30px;
  max-width: 80%;
}

.header-right {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: end;
}

.stepper-container {
  height: 10%;
  padding: 10px;
  background-color: var(--skeleton-bg-card);
}

.second-div {
  margin-top: auto;
  font-size: 0.9rem;
  color: #666;
}
    `
    ]
})
export class LeadSkeletonLoaderComponent {
    @Input() isModal: boolean = false;
}